function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AppContext } from 'context';
import Avatar from 'components/Avatar';
import Account from 'modules/Account';
import messages from '../../../messages';
import layoutStyles from '../MainLayout.pcss';
import styles from './ClinicInfo.pcss';
var _React_PureComponent;
class ClinicInfo extends (_React_PureComponent = React.PureComponent) {
    onManageOrganizationMemberships(evt) {
        evt.preventDefault();
        this.props.onManageOrganizationMemberships();
    }
    get infoMessage() {
        const { isClinicNotConfigured, isClinicPending, isMembershipPending } = this.props;
        if (isClinicNotConfigured) {
            return messages.infos.clinicNotConfigured;
        }
        if (isClinicPending) {
            return messages.infos.waitForApprovalCreate;
        }
        if (isMembershipPending) {
            return messages.infos.waitForApprovalJoin;
        }
        return null;
    }
    renderIntro() {
        const { isClinicPending, isMembershipPending } = this.props;
        let message;
        if (isClinicPending) {
            message = messages.infos.wantToCreate;
        }
        if (isMembershipPending) {
            message = messages.infos.wantToJoin;
        }
        if (!message) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message))
        });
    }
    renderInfo() {
        const { infoMessage } = this;
        if (!infoMessage) {
            return null;
        }
        const apLink = (chunk)=>/*#__PURE__*/ _jsx("a", {
                href: "",
                onClick: (evt)=>this.onManageOrganizationMemberships(evt),
                children: chunk
            });
        return /*#__PURE__*/ _jsx("p", {
            className: styles.info,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, infoMessage), {
                values: {
                    apLink
                }
            }))
        });
    }
    renderLogo(clinic) {
        const { logo, name } = clinic;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.avatar,
            children: /*#__PURE__*/ _jsx(Avatar, {
                avatarImg: logo,
                name: name,
                className: styles.avatar__imgWrapper,
                imgClassName: styles.avatar__img,
                initialsClassName: styles.avatar__initials
            })
        });
    }
    render() {
        const { clinic } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: layoutStyles.container,
            children: /*#__PURE__*/ _jsx("div", {
                className: layoutStyles.containerInner,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "content",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.root,
                        children: [
                            this.renderLogo(clinic),
                            this.renderIntro(),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.clinicName,
                                children: clinic.name
                            }),
                            this.renderInfo()
                        ]
                    })
                })
            })
        });
    }
}
_define_property(ClinicInfo, "contextType", AppContext);
_define_property(ClinicInfo, "propTypes", {
    // Explicit props
    clinic: PropTypes.object.isRequired,
    isClinicNotConfigured: PropTypes.bool,
    isClinicPending: PropTypes.bool,
    isMembershipPending: PropTypes.bool,
    // Implicit actions
    onManageOrganizationMemberships: PropTypes.func
});
const mapDispatchToProps = (dispatch)=>({
        onManageOrganizationMemberships: ()=>dispatch(Account.actions.manageAidOrganizationMemberships())
    });
const ConnectedClinicInfo = connect(null, mapDispatchToProps)(ClinicInfo);
export default withStyles(styles)(ConnectedClinicInfo);
